import type { Category } from "./schema";

export const categories: Category[] = [
  {
    id: "playground",
    name: "놀이터",
    shortName: "놀이",
    color: "#e49a24",
    description: "어린이 놀이터와 실내외 놀이 공간",
  },
  {
    id: "food-cooking",
    name: "음식·요리체험",
    shortName: "요리",
    color: "#c56b39",
    description: "지역 먹거리, 음식 문화와 가족 요리 체험",
  },
  {
    id: "art-performance",
    name: "예술·공연",
    shortName: "예술",
    color: "#9861ad",
    description: "미술, 공연과 가족 예술 체험",
  },
  {
    id: "kids-cafe",
    name: "키즈카페",
    shortName: "키즈",
    color: "#e85d75",
    description: "방방, 정글짐, 대형 실내 놀이시설",
  },
  {
    id: "deullak-nallak",
    name: "들락날락",
    shortName: "들락",
    color: "#7c5cff",
    description: "지역 특화 어린이복합문화공간",
  },
  {
    id: "library",
    name: "도서관",
    shortName: "도서",
    color: "#1f8f71",
    description: "어린이자료실과 독서 프로그램",
  },
  {
    id: "museum",
    name: "박물관",
    shortName: "박물",
    color: "#a05a2c",
    description: "역사, 해양, 지역문화 체험",
  },
  {
    id: "science-creative",
    name: "과학·창의",
    shortName: "과학",
    color: "#177ddc",
    description: "과학관, 안전, 직업, 창의 체험",
  },
  {
    id: "activity",
    name: "액티비티",
    shortName: "활동",
    color: "#f28c28",
    description: "스포츠, 클라이밍, 스케이트, 트램펄린",
  },
  {
    id: "park",
    name: "공원",
    shortName: "공원",
    color: "#4c9f38",
    description: "대형놀이터, 산책, 피크닉",
  },
  {
    id: "sea-water",
    name: "바다·물놀이",
    shortName: "바다",
    color: "#0087a7",
    description: "해수욕장, 물놀이장, 분수",
  },
  {
    id: "transport",
    name: "탈것·교통",
    shortName: "탈것",
    color: "#596579",
    description: "케이블카, 배, 전망, 교통 체험",
  },
  {
    id: "animal-eco",
    name: "동물·생태",
    shortName: "생태",
    color: "#6d8f2f",
    description: "수족관, 생태관, 곤충, 자연 관찰",
  },
  {
    id: "maker",
    name: "만들기·공방",
    shortName: "공방",
    color: "#c356a6",
    description: "공예, 도예, 쿠킹, 손작업",
  },
  {
    id: "art-exhibit",
    name: "미술·전시",
    shortName: "전시",
    color: "#915eb5",
    description: "미술관, 미디어아트, 몰입 전시",
  },
  {
    id: "nature-forest",
    name: "자연·숲",
    shortName: "숲",
    color: "#2f8f83",
    description: "수목원, 숲놀이터, 생태탐방",
  },
  {
    id: "theme-park",
    name: "놀이공원",
    shortName: "테마",
    color: "#dc6b24",
    description: "놀이기구와 테마시설",
  },
  {
    id: "tourism-view",
    name: "관광·전망",
    shortName: "관광",
    color: "#0f7c9f",
    description: "전망대, 로프웨이, 마을, 대표 관광지",
  },
  {
    id: "history-culture",
    name: "역사·문화",
    shortName: "역사",
    color: "#8d6b45",
    description: "유적지, 문화마을, 지역문화 체험",
  },
  {
    id: "waterpark-pool",
    name: "워터파크·수영장",
    shortName: "물놀이",
    color: "#0090c4",
    description: "워터파크, 실내외 수영장, 계절 물놀이",
  },
  {
    id: "farm-ranch",
    name: "농장·목장",
    shortName: "농장",
    color: "#789b2f",
    description: "동물 먹이주기, 수확, 농촌 체험",
  },
  {
    id: "camping-picnic",
    name: "캠핑·피크닉",
    shortName: "캠핑",
    color: "#4f7f59",
    description: "오토캠핑장, 글램핑, 피크닉형 체류지",
  },
  {
    id: "festival-seasonal",
    name: "축제·계절행사",
    shortName: "축제",
    color: "#d24f45",
    description: "기간 한정 행사, 꽃축제, 어린이 공연·팝업",
  },
];

export const categoryById = Object.fromEntries(
  categories.map((category) => [category.id, category]),
) as Record<Category["id"], Category>;
